import { v4 as uuidv4 } from "uuid";
import { toast } from 'react-toastify';
const { createSlice } = require("@reduxjs/toolkit");

const cartSlice = createSlice({
  name: "cart",
  initialState: {
    cartItems: [],
  },
  reducers: {
    addToCart(state, action) {
      const product = action.payload;

      if (product) {
        const cartItem = state.cartItems.find(
          (item) => item.productVariationId === product.productVariationId
        );

        if (!cartItem) {
          state.cartItems.push({
            ...product,
            quantity: product.quantity ? product.quantity : 1,
            cartItemId: uuidv4(),
          });
        } else {
          state.cartItems = state.cartItems.map((item) => {
            if (item.productVariationId === cartItem.productVariationId) {
              return {
                ...item,
                price: product.price,
                discount: product.discount,
                saleprice: product.saleprice,
                quantity: product.quantity,
              };
            }
            return item;
          });
        }
      }
    },
    addAllToCart(state, action) {
      state.cartItems = action.payload;
    },
    deleteFromCart(state, action) {
      state.cartItems = state.cartItems.filter(
        (item) => item.productVariationId !== action.payload
      );
      toast.error("Removed From Cart", { position: "bottom-left" });
    },
    decreaseQuantity(state, action) {
      const product = action.payload;
      if (product.quantity === 1) {
        state.cartItems = state.cartItems.filter(
          (item) => item.productVariationId !== product.productVariationId
        );
        toast.error("Removed From Cart", { position: "bottom-left" });
      } else {
        state.cartItems = state.cartItems.map((item) =>
          item.productVariationId === product.productVariationId
            ? { ...item, quantity: item.quantity - 1 }
            : item
        );
        toast.warn("Item Decremented From Cart", {
          position: "bottom-left",
        });
      }
    },
    deleteAllFromCart(state) {
      state.cartItems = [];
    },
  },
});

export const {
  addToCart,
  addAllToCart,
  deleteFromCart,
  decreaseQuantity,
  deleteAllFromCart,
} = cartSlice.actions;
export default cartSlice.reducer;
